module.exports = __webpack_public_path__ + "app-static/img/p_11.1061797d.jpg";